import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { FlowTemplate } from '../interfaces';
import { axiosBaseQuery } from './base.service';

export const FlowTemplatesService = createApi({
  reducerPath: 'FlowTemplatesService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getFlowTemplates: builder.query<FlowTemplate[], void>({
      query: () => ({
        url: '/v1/flow_templates',
        method: HttpMethod.GET,
      }),
    }),
  }),
});

export const { useGetFlowTemplatesQuery } = FlowTemplatesService;
